<script setup lang="ts">
interface Props {
  src?: string
  initials?: string
  size?: number
  color?: string
}

withDefaults(defineProps<Props>(), {
  src: '',
  initials: '',
  size: 40,
  color: 'primary',
})
</script>

<template>
  <v-avatar
    :size="size"
    :color="src ? undefined : color"
  >
    <v-img
      v-if="src"
      :src="src"
    />
    <span v-else>{{ initials }}</span>
  </v-avatar>
</template>

<style scoped lang="scss">
</style>
